import { ConfigLogLevel, Realms } from "./types";

export const environmentsByZendeskRealmUrl: { [key: string]: Realms } = {
  "localhost:3000": Realms.local,
  "sendgridtest.zendesk.com": Realms.dev,
  "d3v-twlo.zendesk.com": Realms.stage,
  "support.sendgrid.com": Realms.prod,
};

export const logLevelsByRealm: Record<string, ConfigLogLevel> = {
  local: ConfigLogLevel.debug,
  dev: ConfigLogLevel.debug,
  stage: ConfigLogLevel.debug,
  prod: ConfigLogLevel.info,
};
